"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var context_1 = require("./context");
/**
 * withLDConsumer is a function which accepts an optional options object and returns a function
 * which accepts your React component. This function returns a HOC with flags
 * and the ldClient instance injected via props.
 *
 * @param options - If you need only the `ldClient` instance and not flags, then set `{ clientOnly: true }`
 * to only pass the ldClient prop to your component. Defaults to `{ clientOnly: false }`.
 * @return A HOC with flags and the `ldClient` instance injected via props
 */


function withLDConsumer() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    clientOnly: false
  };
  return function withLDConsumerHoc(WrappedComponent) {
    return function (props) {
      return React.createElement(context_1.Consumer, null, function (_ref) {
        var flags = _ref.flags,
            ldClient = _ref.ldClient;

        if (options.clientOnly) {
          return React.createElement(WrappedComponent, Object.assign({
            ldClient: ldClient
          }, props));
        }

        return React.createElement(WrappedComponent, Object.assign({
          flags: flags,
          ldClient: ldClient
        }, props));
      });
    };
  };
}

exports.default = withLDConsumer;